<template>

  <div :class="isVisible ? 'c-cookie' : 'c-cookie is-accepted'">

    <div class="c-cookie__content" v-html="$globals.general.cookieBanner"></div>

    <a href="accept"
        v-on:click.prevent="setCookie"
        class="c-cookie__btn">
        {{ $globals.general.cookieAccept }}
    </a>

  </div>

</template>

<script>
/*
* COOKIE - component
* ===
*/
import { mapState } from 'vuex'

export default {
  name: 'Cookies',

  data () {
    return {
      isVisible: true
    }
  },

  methods: {

    setCookie () {
      const days = 99999

      let expires

      if (days) {
        const date = new Date()
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
        expires = `; expires=${date.toGMTString()}`
      } else expires = ``

      document.cookie = `cookiebar=hide${expires}; path=/`

      this.isVisible = false
    }

  },

  computed: {

    ...mapState({

      // message: state => state.globals.cookieBanner,
      // accept: state => state.globals.cookieAccept

    })
  }
}
</script>
